import React, { useEffect, useState } from "react";
import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import RouteConstants from "./constants/routesContent.json";
import Login from "./containers/Login";
import HomePageView from "./containers/Home";
import StatusZoneView from "./containers/StatusZone";
import StatusView from "./containers/Status";
import GuestRegisterView from "./containers/GuestRegister";
import ResetPassword from "./containers/LoginResetPassword";
import ForgotPassword from "./containers/ForgotPassword";
import EmailVerification from "./containers/EmailVerfication";
import VisitorsMappingPage from "./containers/VisitorsMapping";
import VisitorsDetailPage from "./containers/VisitorsDetails";
import StatusCategoryPage from "./containers/StatusCategory";
import StatusEmployeeView from "./containers/StatusEmployee";
import EvacuationView from "./containers/ERT";
import EmployeeRegistartionPage from "./containers/EmployeeRegistration";
import ERTDetailView from "./containers/ERTDetails";
import EmployeeMasterpage from "./containers/EmployeeMaster";
import DeviceSettingsPage from "./containers/Settings";
import SettingsRoleManagement from "./containers/SettingsRoleManagement";
import VehicleDetailsPage from "./containers/ReportVehicleDetails";
import ReportZonePage from "./containers/ReportZone";
import SettingsRole from "./containers/SettingsRole/";
import SettingsPermission from "./containers/SettingsPermission";
import ProfileView from "./containers/Profile";
import RoleAssignPage from "./containers/RoleAssign";
import EmployeeDetail from "./containers/EmployeeDetail";
import ReportView from "./containers/Report";
import AddDevice from "./containers/AddDevice";
import SafeAssemblePoint from "./containers/SafeAssemblePoint";
import StatusERT from "./containers/StatusERT";
import StatusERTDetails from "./containers/StatusERTDetails";
import StatusAll from "./containers/StatusAll";
import Contacts from "./containers/Contacts";
import jwt_decode from "jwt-decode";
import { useNavigate } from "react-router-dom";
import deviceValue from "./constants/dummyData.json";
import { loginApi, createAccessToken } from "./api/Api";
import { createCookie } from "./utils/service";
function App() {
  const submitAccessToken = async () => {
    const data = {
      refreshToken: localStorage.getItem("x-referesh-token"),
    };
    try {
      const getData = await createAccessToken(data);
      if (getData.data.status === 200) {
        const token = getData.data.data.accessToken;
        localStorage.setItem("x-access-token", token);
        createCookie("accessToken", token, 30);
        // navigate(RouteConstants.HOMEPAGE), {
        //   state: localStorage.getItem('permissions'),
        // };
      }
    } catch (error) {
      if (
        error.response.data.status === 400 ||
        error.response.data.status === 401
      ) {
        // setAlertMessage(error.response.data.message);
        // setShowAlert(true);
      } else {
        // setAlertMessage("Somthing went wrong");
        // setShowAlert(false);
      }
    }
  };

  const [cookieVal, setCookieVal] = useState(
    localStorage.getItem("x-access-token")
  );

  useEffect(() => {
    let firstIntervalId = "";
    let secondIntervalId = "";
    const isRemeber = localStorage.getItem("remember");
    if (isRemeber === "true") {
      firstIntervalId = setInterval(() => {
        if (localStorage.getItem("x-access-token") !== cookieVal) {
          setCookieVal(localStorage.getItem("x-access-token"));
        }
      }, 500);

      secondIntervalId = setInterval(() => {
        const accessToken = localStorage.getItem("x-access-token");
        const decodedData = jwt_decode(accessToken);
        if (Date.now() >= decodedData.exp * 1000) {
          submitAccessToken();
          clearInterval(secondIntervalId);
        }
      }, 1000);
    }

    return () => {
      clearInterval(firstIntervalId);
      clearInterval(secondIntervalId);
    };
  }, [cookieVal]);

  return (
    <div className="App">
      <Router>
        <Routes>
          <Route exact path={RouteConstants.LOGIN} element={<Login />} />
          <Route
            exact
            path={RouteConstants.HOMEPAGE}
            element={<HomePageView />}
          />
          <Route
            exact
            path={RouteConstants.RESET_PASSWORD}
            element={<ResetPassword />}
          />
          <Route
            exact
            path={RouteConstants.VISITORS_MAPPING}
            element={<VisitorsMappingPage />}
          />
          <Route
            exact
            path={RouteConstants.GUEST_REGISTER}
            element={<GuestRegisterView />}
          />
          <Route
            exact
            path={RouteConstants.STATUSZONE}
            element={<StatusZoneView />}
          />
          <Route exact path={RouteConstants.STATUS} element={<StatusView />} />
          <Route
            exact
            path={RouteConstants.VISITORS_DETAILS}
            element={<VisitorsDetailPage />}
          />
          <Route
            path={RouteConstants.FORGOT_PASSWORD}
            element={<ForgotPassword />}
          />
          <Route
            exact
            path={RouteConstants.EMAIL_VERIFICATION}
            element={<EmailVerification />}
          />
          <Route
            exact
            path={RouteConstants.STATUS_CATEGORY}
            element={<StatusCategoryPage />}
          />

          <Route
            exact
            path={RouteConstants.STATUS_EMPLOYEE}
            element={<StatusEmployeeView />}
          />
          <Route
            exact
            path={RouteConstants.EVACUATION}
            element={<EvacuationView />}
          />
          <Route
            exact
            path={RouteConstants.EMPLOYEE_REGISTRATION}
            element={<EmployeeRegistartionPage />}
          />
          <Route
            exact
            path={RouteConstants.REPORT_ZONE}
            element={<ReportZonePage />}
          />
          <Route
            exact
            path={RouteConstants.ERT_DETAILS}
            element={<ERTDetailView />}
          />
          <Route
            exact
            path={RouteConstants.EMPLOYEE_MASTER}
            element={<EmployeeMasterpage />}
          />
          <Route
            exact
            path={RouteConstants.SETTINGS}
            element={<DeviceSettingsPage />}
          />
          <Route
            exact
            path={RouteConstants.VEHICLE_DETAILS}
            element={<VehicleDetailsPage />}
          />
          <Route
            exact
            path={RouteConstants.SETTINGS_ROLE_MANAGEMENT}
            element={<SettingsRoleManagement />}
          />
          <Route
            exact
            path={RouteConstants.REPORT_ZONE}
            element={<ReportZonePage />}
          />
          <Route
            exact
            path={RouteConstants.ERT_DETAILS}
            element={<ERTDetailView />}
          />
          <Route
            exact
            path={RouteConstants.EMPLOYEE_MASTER}
            element={<EmployeeMasterpage />}
          />
          <Route
            exact
            path={RouteConstants.SETTINGS}
            element={<DeviceSettingsPage />}
          />
          <Route exact path={RouteConstants.REPORT} element={<ReportView />} />
          <Route
            exact
            path={RouteConstants.PROFILE_DETAILS_EMP}
            element={<ProfileView />}
          />
          <Route
            exact
            path={RouteConstants.VEHICLE_DETAILS}
            element={<VehicleDetailsPage />}
          />
          <Route
            exact
            path={RouteConstants.EMPLOYEE_DETAILS}
            element={<EmployeeDetail />}
          />
          <Route
            exact
            path={RouteConstants.ROLE_ASSIGN}
            element={<RoleAssignPage />}
          />
          <Route
            exact
            path={RouteConstants.SETTINGS_ROLE}
            element={<SettingsRole />}
          />
          <Route
            exact
            path={RouteConstants.SETTINGS_PERMISSION}
            element={<SettingsPermission />}
          />
          <Route
            exact
            path={RouteConstants.ADD_DEVICE}
            element={<AddDevice />}
          />
          <Route
            exact
            path={RouteConstants.STATUS_ERT}
            element={<StatusERT />}
          />
          <Route
            exact
            path={RouteConstants.STATUS_ERT_DETAILS}
            element={<StatusERTDetails />}
          />
          <Route
            exact
            path={RouteConstants.SAFE_ASSEMBLE_POINT}
            element={<SafeAssemblePoint />}
          ></Route>
          <Route
            exact
            path={RouteConstants.CONTACTS}
            element={<Contacts />}
          ></Route>
          <Route
            exact
            path={RouteConstants.STATUS_ALL}
            element={<StatusAll />}
          ></Route>
        </Routes>
      </Router>
    </div>
  );
}

export default App;
